import React from 'react';
import classNames from 'classnames';

const Paragraph = props => {
  const { prefixCls, className, rows = 2, width, style } = props;
  const getWidth = index => {
    if (Array.isArray(width)) {
      return width[index];
    }
    if (rows - 1 === index) {
      return width;
    }
    return undefined;
  };
  const rowList = [...Array(rows)].map((_, index) => (
    <li key={index} style={{ width: getWidth(index) }} />
  ));
  return (
    <ul className={classNames(prefixCls, className)} style={style}>
      {rowList}
    </ul>
  );
};
export default Paragraph;



// WEBPACK FOOTER //
// ./src/skeleton/Paragraph.jsx